import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slices/cartSlice';
import carouselReducer from './slices/carouselSlice';
import registrationReducer from './slices/registrationSlice';
import currencyReducer from './slices/currencySlice';

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    carousel: carouselReducer,
    registration: registrationReducer,
    currency: currencyReducer,
    // Add reducers here
    // user: userSlice,
    // product: productSlice,
    // order: orderSlice,
  },
});

// Type exports (for TypeScript projects)
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
